import { render, staticRenderFns } from "./editParrafo.vue?vue&type=template&id=bcb96bae"
import script from "./editParrafo.vue?vue&type=script&lang=js"
export * from "./editParrafo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports